import { useEffect } from 'react';

export function useHiddenField(
  containerId: string,
  fieldName: string,
  onFound: (input: HTMLInputElement) => void,
  options?: {
    timeoutMs?: number;
  },
) {
  useEffect(() => {
    const container = document.getElementById(containerId);
    if (!container) return;

    const find = () =>
      container.querySelector<HTMLInputElement>(
        `input[type="hidden"][name="${fieldName}"]`,
      );

    const existing = find();
    if (existing) {
      onFound(existing);
      return;
    }

    const observer = new MutationObserver(() => {
      const input = find();
      if (input) {
        observer.disconnect();
        onFound(input);
      }
    });

    observer.observe(container, {
      childList: true,
      subtree: true,
    });

    const timeout = window.setTimeout(
      () => observer.disconnect(),
      options?.timeoutMs ?? 10_000,
    );

    return () => {
      observer.disconnect();
      clearTimeout(timeout);
    };
  }, [containerId, fieldName]);
}
